export default {
  "menu.CompanyManagePage": "场所管理页",
}